// extracted by mini-css-extract-plugin
export default {"wrap":"ME-z","fullWidth":"NE-z","hideOnDesktop":"OE-z","content":"PE-z","hasOpenedNav":"QE-z","crumbsList":"RE-z","dropdownsWrap":"SE-z"};